export const isAndroid = /MGPOS/i.test(navigator.userAgent)
